export const Logo = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" data-testid="poween-logo" aria-label="Pupoweenwifhat logo">
        <defs>
            <radialGradient id="lg" cx="50%" cy="40%" r="70%">
                <stop offset="0%" stopColor="#FF8C00" />
                <stop offset="100%" stopColor="#E05A00" />
            </radialGradient>
        </defs>
        <circle cx="32" cy="36" r="24" fill="url(#lg)" />
        <path d="M32 12c-2-6 2-8 6-9-1 4-1 7-3 10z" fill="#4A7A2F" />
        <path d="M20 30l6 4-6 4zM44 30l-6 4 6 4z" fill="#0D0B14" />
        <path d="M24 46c3 4 13 4 16 0l-3-3h-10z" fill="#0D0B14" />
        <circle cx="24" cy="38" r="2.4" fill="#00FF87" />
        <circle cx="40" cy="38" r="2.4" fill="#00FF87" />
    </svg>
);
